export default {
  state: {
    enterpriseId: undefined,
  },
  mutations: {
    SET_ENTERPRISE_ID: (state, enterpriseId) => {
      state.enterpriseId = enterpriseId
    },
  },
  getters: {
    enterpriseId: state => state.enterpriseId
  },
  actions: {
    setEnterpriseId({commit}, enterpriseId) {
      return new Promise((resolve) => {
        commit('SET_ENTERPRISE_ID', enterpriseId);
        resolve();
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/businessData.js